export default __webpack_public_path__ + "static/media/circle-plus.276a9d87.svg";